/** @jsx jsx */
import { css, jsx } from "@emotion/core"

import { Fields } from "@cd2/forms"
import { Table } from "@cd2/components/build/es6"

interface ICheckboxColumnProps {
  values: (string | number)[]
  field: string
  rowDisabled?: (data: any) => boolean

  onChange(values: (string | number)[]): void
}

export function CheckboxColumn({
  values = [],
  onChange,
  field,
  rowDisabled = () => false,
}: ICheckboxColumnProps) {
  const table = Table.useTable()
  // Get the length of the table data of rows that are not disabled and the value is in values
  const noneChecked =
    table.data.filter(val => !rowDisabled(val) && values.includes(val[field])).length === 0
  // compare the length of the number of non disabled values against the total non disabled table data length
  const allChecked =
    table.data.filter(val => !rowDisabled(val) && values.includes(val[field])).length ===
    table.data.filter(val => !rowDisabled(val)).length
  const partialChecked = !noneChecked && !allChecked

  function handleChange(isChecked: boolean, value: string | number) {
    if (isChecked) {
      onChange(values.filter(val => val !== value))
    } else {
      onChange([...values, value])
    }
  }

  function handleHeadingChange() {
    if (partialChecked || noneChecked) {
      // when checking all, keep the disabled rows unchanged (if disabled, check that the value was already checked)
      onChange(
        table.data
          .filter(val => !rowDisabled(val) || (rowDisabled(val) && values.includes(val[field])))
          .map(datum => datum[field]),
      )
    } else {
      // when un-checking all, ensure that values that are checked and disabled remain
      onChange(
        table.data
          .filter(val => rowDisabled(val) && values.includes(val[field]))
          .map(datum => datum[field]),
      )
    }
  }

  if (table.isHeading) {
    return (
      <th
        onClick={e => e.stopPropagation()}
        css={css`
          width: 1px;
          padding-left: 10px;
          padding-bottom: 5px;
        `}
      >
        <Fields.Checkbox
          indeterminate={partialChecked}
          value={allChecked}
          onChange={() => handleHeadingChange()}
        />
      </th>
    )
  } else {
    const elementChecked = values.includes(table.row[field])

    return (
      <td
        onClick={e => e.stopPropagation()}
        css={css`
          width: 1px;
          padding-left: 10px;
        `}
      >
        <Fields.Checkbox
          onChange={() => handleChange(elementChecked, table.row[field])}
          value={elementChecked}
          disabled={rowDisabled(table.row)}
        />
      </td>
    )
  }
}
